import React from 'react';
import { Await } from '../../../components/Await';
import {
    BLOG_POSTS_PAGE_SIZE,
    imageUrl,
    useSanity,
} from '../../../lib/landingPage';
import { classes } from '../../../lib';
import { SanityObject } from '../../../lib/landingPage';
import { observer } from 'mobx-react-lite';
import { Footer } from '../Footer';
import { Header } from '../Header';
import { BlogSubmenu } from '../BlogSubmenu';
import Styles from './AludeNews.module.less';
import { categoriesQuery } from '../BlogPage/BlogHomePage';
import { ImageProps } from '../Image';
import { AludeNewsPostPreview } from '../../../components/landingPage/AludeNewsPostPreview';
import { NewsletterForm } from '../../../components/landingPage/NewsletterForm';
import { BlogPostCategory } from '../../../components/landingPage/BlogPost';
import _ from 'lodash';
import { Button } from '../../../components/Button';

export type AludeNewsPostProps = {
    imageRef: SanityObject<ImageProps>;
    subject: string;
    html: string;
    slug: string;
};

export type AludeNewsPageResolvedProps = {
    categories: BlogPostCategory[];
};

const Posts = observer(
    ({
        posts,
        nextPage,
        isLastPage,
    }: {
        posts: SanityObject<AludeNewsPostProps>[];
        nextPage: () => void;
        isLastPage: boolean;
    }) => {
        return (
            <>
                <div className={classes(Styles.postsGrid)}>
                    {posts.slice(0, BLOG_POSTS_PAGE_SIZE).map(p => (
                        <AludeNewsPostPreview
                            key={p.slug}
                            image={imageUrl(p.imageRef.image, 'blog').url()}
                            subject={p.subject}
                            slug={p.slug}
                        />
                    ))}
                </div>
                {isLastPage && posts.length > BLOG_POSTS_PAGE_SIZE && (
                    <div className="horizontal center-middle">
                        <Button onClick={nextPage} type="link">
                            Carregar mais...
                        </Button>
                    </div>
                )}
            </>
        );
    }
);

export const AludeNewsPageResolved = observer(
    ({ categories }: AludeNewsPageResolvedProps) => {
        const sanity = useSanity();
        const [pages, setPages] = React.useState(0);
        return (
            <>
                <Header showSignupButton />
                <BlogSubmenu categories={categories} />
                <div
                    className={classes(
                        Styles.mainContainer,
                        'vertical between-middle mt-px16 mt-py24 mt-g24 d-px32 d-py48 d-g48'
                    )}>
                    <NewsletterForm />
                    {_.range(pages + 1).map(p => (
                        <Await
                            key={p}
                            views={{
                                posts: sanity.asyncAludeNewsPosts(p),
                            }}
                            resolved={Posts}
                            extra={{
                                nextPage: () => setPages(pages + 1),
                                isLastPage: p === pages,
                            }}
                        />
                    ))}
                </div>
                <Footer hideMenu={false} />
            </>
        );
    }
);

export const AludeNewsPage = observer(() => {
    const sanity = useSanity();
    return (
        <Await
            views={{
                categories: sanity.asyncBlog(categoriesQuery),
            }}
            resolved={AludeNewsPageResolved}
        />
    );
});
